import { Card, CardContent, CardHeader } from '@optools/components/ui/card';
import { UserSession } from '@optools/services/operator-gateway/user-lookup/types';

import { CardField } from './card-field';

interface SessionProps {
  session: UserSession;
}

export function SessionDetails({ session }: SessionProps) {
  return (
    <div className="flex w-full items-center p-2">
      <div className="flex grow gap-2">
        <Card className="flex min-w-max flex-col gap-2 p-4" data-testid="location-details">
          <CardHeader className="p-0 font-bold">Location</CardHeader>
          <CardContent className="flex max-h-52 flex-col gap-1 overflow-hidden p-0">
            <CardField label="Zip" value={session.location.zip} />
            <CardField label="Country" value={session.location.country} />
            <CardField label="Latitude" value={session.location.latitude} />
            <CardField label="Longitude" value={session.location.longitude} />
            <CardField
              label="Designated Market Area"
              value={session.location.designatedMarketArea}
            />
            <CardField label="Location Provider" value={session.location.locationProvider} />
          </CardContent>
        </Card>
        <Card className="flex min-w-max flex-col gap-2 p-4" data-testid="device-details">
          <CardHeader className="p-0 font-bold">Device</CardHeader>
          <CardContent className="border-box flex max-h-52 flex-col flex-wrap gap-1 p-0">
            <CardField label="ID" value={session.device.id} />
            <CardField label="OS" value={session.device.os} />
            <CardField label="Device Version" value={session.device.version} />
            <CardField label="Platform" value={session.device.platform} />
            <CardField label="Ip Address" value={session.device.ipAddress} />
            <CardField label="User Agent" value={session.device.userAgent} />
            <CardField label="Application Runtime" value={session.device.applicationRuntime} />
            <CardField label="Language" value={session.device.language} />
            <CardField label="Profile" value={session.device.profile} />
            <CardField label="Manufacturer" value={session.device.manufacturer} />
            <CardField label="Model" value={session.device.model} />
            <CardField label="Extra Attributes" value={session.device.extraAttributes} />
            <CardField label="App Version" value={session.device.appVersion} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
